import type { LocationQuery } from 'vue-router'

export const ROUTE_QUERY_IS_PROJECT_REQUEST = 'isProjectRequest'

export const ROUTE_QUERY_IS_PROJECT_REQUEST_ACTIVE = '1'

export const ROUTE_QUERY_RETURN_TO_PROJECT_REQUEST_FORM = 'returnToProjectRequestForm'

export const ROUTE_QUERY_RETURN_TO_PROJECT_REQUEST_FORM_ACTIVE = '1'

/** Открыть виджет создания кастомного модуля на форме заявки/проекта (шаг редактирования). */
export const ROUTE_QUERY_OPEN_CUSTOM_MODULE_CREATE = 'openCustomModuleCreate'

export const ROUTE_QUERY_OPEN_CUSTOM_MODULE_CREATE_ACTIVE = '1'

export function isProjectRequestRouteQuery(query: LocationQuery): boolean {
  const raw = query[ROUTE_QUERY_IS_PROJECT_REQUEST]
  const value = typeof raw === 'string' ? raw : Array.isArray(raw) ? raw[0] : undefined
  return value === ROUTE_QUERY_IS_PROJECT_REQUEST_ACTIVE || value === 'true'
}

export function isReturnToProjectRequestFormQuery(query: LocationQuery): boolean {
  const raw = query[ROUTE_QUERY_RETURN_TO_PROJECT_REQUEST_FORM]
  const value = typeof raw === 'string' ? raw : Array.isArray(raw) ? raw[0] : undefined
  return value === ROUTE_QUERY_RETURN_TO_PROJECT_REQUEST_FORM_ACTIVE || value === 'true'
}

export function shouldNavigateToProjectRequestFormAfterTemplateSave(query: LocationQuery): boolean {
  return isProjectRequestRouteQuery(query) || isReturnToProjectRequestFormQuery(query)
}

export function isOpenCustomModuleCreateQuery(query: LocationQuery): boolean {
  const raw = query[ROUTE_QUERY_OPEN_CUSTOM_MODULE_CREATE]
  const value = typeof raw === 'string' ? raw : Array.isArray(raw) ? raw[0] : undefined
  return value === ROUTE_QUERY_OPEN_CUSTOM_MODULE_CREATE_ACTIVE || value === 'true'
}
